import React from "react";
import { getColor } from "core/utils";

const GiftBow = props => {
	const holidayRed = getColor("holidayRed");
	return (
		<svg
			viewBox="12 12 107 107"
			width="107"
			height="107"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<path
					d="m12.532 65.718 44-26.936 18.5-27h15l-77.5 73V65.718Z"
					fill={holidayRed}
				/>
				<path
					d="m21.032 73.282 65.5-61.5h3.43L13.045 84.357l7.988-11.075Z"
					fill="#AE0000"
				/>
				<g>
					<path
						d="m34.51 56.614-3.364 14.989 17.258 8.146-1.559-27.959-12.336 4.825Z"
						fill="#D6121C"
					/>
					<path
						d="M41.629 42.19c-3.922-.313-17.926-.239-22.218 2.093-4.292 2.332-3.832 6.59-3.235 7.688l2.86 5.265 3.755 6.912c.746 1.373 2.766 4.722 9.097.037 6.33-4.684 15.621-13.035 15.621-13.035l-5.88-8.96Z"
						fill={holidayRed}
					/>
					<path
						d="M25.724 58.284c-2.936 1.062-3.85 4.543-2.933 5.863.746 1.373 2.767 4.723 9.097.038C38.218 59.5 46.845 51.79 46.845 51.79c-4.594 1.073-18.185 5.433-21.121 6.494Z"
						fill="#AE0000"
					/>
					<path
						d="m67.71 38.577 14.405 5.335-2.558 18.912L56.95 46.3l10.76-7.724Z"
						fill="#D6121C"
					/>
					<path
						d="M51.734 36.7c1.872-3.46 9.555-15.169 13.847-17.5 4.292-2.332 7.613.37 8.21 1.469l2.86 5.265 3.756 6.912c.746 1.373 2.456 4.89-4.92 7.652-7.373 2.76-19.436 6.012-19.436 6.012l-4.317-9.81Z"
						fill={holidayRed}
					/>
					<path
						d="M73.892 32.115c2.489-1.886 5.906-.757 6.515.73.746 1.373 2.456 4.891-4.92 7.653C68.115 43.258 56.95 46.3 56.95 46.3c3.4-3.27 14.454-12.3 16.942-14.186ZM46.427 38.976l-5.811 3.157 6.23 9.657 5.051-2.745 5.053-2.744-4.712-10.482-5.811 3.157Z"
						fill="#AE0000"
					/>
				</g>
			</g>
			<defs>
				<filter
					id="a"
					x={0.137}
					y={2.563}
					width={105.979}
					height={103.49}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy={3} />
					<feGaussianBlur stdDeviation={5} />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
					<feBlend
						in2="BackgroundImageFix"
						result="effect1_dropShadow_200_4202"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect1_dropShadow_200_4202"
						result="shape"
					/>
				</filter>
				<filter
					id="c"
					x={5.795}
					y={11.279}
					width={86.32}
					height={81.47}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy={3} />
					<feGaussianBlur stdDeviation={5} />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
					<feBlend
						in2="BackgroundImageFix"
						result="effect1_dropShadow_200_4202"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect1_dropShadow_200_4202"
						result="shape"
					/>
				</filter>
				<clipPath id="b">
					<path
						fill="#fff"
						transform="rotate(-28.515 85.495 .49)"
						d="M0 0h65.587v59.384H0z"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default GiftBow;
